@use '@fpsm/cxy-scss' as cxy;

.verifyPayment {
  @include cxy.stack(var(--cxy-spacing-3));
}

.loaderContainer {
  display: flex;
  align-items: center;
  justify-content: center;
}

.content {
  @include cxy.stack(var(--cxy-spacing-xxsm));
}

.text {
  font-size: var(--cxy-fontSize-m);
  color: var(--cxy-color-text-default-body);
  text-align: center;
}
